export const formDefaultValues = {
  diagnosis: '',
  medication: '',
  quantity: '',
  indications: '',
}
